import React, { memo } from 'react';
import { Text, useTheme } from '@Sage/hoi-poi-ui';
import { getLiteral } from 'utils/getLiteral';

import './styles.scss';

/**
 * Shared tooltip content for the "record cannot be edited" state used across
 * detail headers, list row indicators and disabled edit/delete/merge buttons
 * (GOKU-11242).
 *
 * When `isPublicCompany` is true, uses the public-account readonly literals.
 * Otherwise uses the generic readonly literals.
 */
const ReadOnlyTooltipContent = memo(({ isPublicCompany = false }) => {
    const theme = useTheme();

    const title = isPublicCompany
        ? getLiteral('label_detail_public_and_redonly_account')
        : getLiteral('label_detail_readonly');
    const description = isPublicCompany
        ? getLiteral('label_detail_public_readonly_account_no_edit')
        : getLiteral('label_detail_readonly_no_edit');

    return (
        <div className="fm-readonly-indicator__content">
            <Text className="fm-readonly-indicator__title" type="subtitle" medium>
                {title}
            </Text>
            <Text
                className="fm-readonly-indicator__description"
                color={theme.colors.utility.textSecondary}
            >
                {description}
            </Text>
        </div>
    );
});

export default ReadOnlyTooltipContent;
